import sanitize from 'sanitize-html';

export const getIntlString = (
  messageStore: {[key: string]: string},
  key: string,
  variables?: {[key: string]: string}
) => {
  let message = messageStore[key] || key;

  if (variables && Object.keys(variables)?.length) {
    Object.keys(variables).forEach((i) => {
      message = message.replace(new RegExp(`{{${i}}}`, 'gi'), variables[i]);
    });
  }

  return sanitize(message);
};

export const replaceLineBreak = (text: string) =>
  text?.replace(/\r\n|\n/g, '<br/>') || '';

export const replaceBrTag = (text: string) =>
  text?.replace(/<br\/>/g, '\n') || '';
